import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1" }
const _hoisted_2 = { class: "_mb-3" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_4 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_5 = { class: "_flex _jc-sb _fd-c _fd-r--m" }
const _hoisted_6 = { class: "_mt-0" }
const _hoisted_7 = { class: "_flex _jc-sb _ai-c _shrink-0" }
const _hoisted_8 = { class: "_flex _jc-sb _fd-c _fd-r--m" }
const _hoisted_9 = { class: "_mt-0" }
const _hoisted_10 = { class: "_flex _jc-sb _ai-c _shrink-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.SubscriptionManagement.SystemNotificationHeader), 1 /* TEXT */),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.systemMessages,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => ((_ctx.model.systemMessages) = $event)),
              $options.onSystemMessageNotificationPreferenceChange
            ],
            "first-column-width": 8,
            "read-only": true,
            options: $options.basePreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.SystemMessagesFieldLabel,
            name: "model.systemMessages",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.SystemMessagesFieldDescription,
            "data-qa": "general-notifications:SystemMessages"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          ($options.isFeastNewsletterEnabled)
            ? (_openBlock(), _createBlock(_component_option_field, {
                key: 0,
                modelValue: _ctx.model.feast,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = $event => ((_ctx.model.feast) = $event)),
                  $options.onFestNotificationPreferenceChange
                ],
                "first-column-width": 8,
                options: $options.basePreferenceOptions,
                "display-name": _ctx.Resources.SubscriptionManagement.FeastFieldLabel,
                name: "model.feast",
                layout: "columns",
                class: "_mb-3",
                description: _ctx.Resources.SubscriptionManagement.FeastFieldDescription,
                "data-qa": "general-notifications:Feast"
              }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.newsletter,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => ((_ctx.model.newsletter) = $event)),
              $options.onNewsletterNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.basePreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.NewsletterFieldLabel,
            name: "model.newsletter",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.NewsletterFieldDescription,
            "data-qa": "general-notifications:Newsletter"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.commentReply,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = $event => ((_ctx.model.commentReply) = $event)),
              $options.onCommentReplyNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.notificationPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.CommentRepliesFieldLabel,
            name: "model.commentReply",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.CommentRepliesFieldDescription,
            "data-qa": "general-notifications:CommentReply"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.preferredDigestFrequency,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = $event => ((_ctx.model.preferredDigestFrequency) = $event)),
              $options.onDigestFrequencyNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.digestFrequencyPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.CommunityLifeFieldLabel,
            name: "model.preferredDigestFrequency",
            layout: "columns",
            class: "_mt-0",
            description: _ctx.Resources.SubscriptionManagement.CommunityLifeFieldDescription,
            "data-qa": "general-notifications:CommunityLife"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Resources.SubscriptionManagement.ProjectNotificationHeader), 1 /* TEXT */),
          ($options.isEnablePushNotificationsMessageVisible)
            ? (_openBlock(), _createBlock(_component_base_notificator, {
                key: 0,
                class: "_my-3",
                "can-close": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_progress_overlay, {
                    visible: this.isProcessing
                  }, null, 8 /* PROPS */, ["visible"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushEnableParagraph), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "_pa-0 _mx-1 _tdu",
                        onClick: _cache[5] || (_cache[5] = (...args) => ($options.onNotificationHide && $options.onNotificationHide(...args))),
                        "data-qa": "push-notification:HideThisMessage"
                      }, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushHideLabel), 1 /* TEXT */),
                      _createVNode(_component_base_button, {
                        class: "_ml-a",
                        theme: "transparentInverse",
                        onClick: $options.onActivatePushNotifications,
                        "data-qa": "push-notification:Activate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushActivateLabel), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          ($options.isPushNotificationsBlockedByBrowserMessageVisible)
            ? (_openBlock(), _createBlock(_component_base_notificator, {
                key: 1,
                class: "_my-3",
                "can-close": false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushBlockedByBrowserParagraph), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "_pa-0 _mx-1 _tdu",
                        onClick: _cache[6] || (_cache[6] = (...args) => ($options.onNotificationHide && $options.onNotificationHide(...args))),
                        "data-qa": "push-notification:HideThisMessage"
                      }, _toDisplayString(_ctx.Resources.SubscriptionManagement.WebPushHideLabel), 1 /* TEXT */),
                      _createVNode(_component_base_button, {
                        class: "_ml-a",
                        theme: "transparentInverse",
                        tag: "a",
                        href: $options.browserHelpUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: $options.onBrowserHelpButtonClick,
                        "data-qa": "push-notification:ReadInstructions"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushHowToUnblockLink), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["href", "onClick"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.projectMilestones,
            "onUpdate:modelValue": [
              _cache[7] || (_cache[7] = $event => ((_ctx.model.projectMilestones) = $event)),
              $options.onProjectMilestonesNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.notificationPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.ProjectMilestonesFieldLabel,
            name: "model.projectMilestones",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.ProjectMilestonesInputFieldDescription,
            "data-qa": "general-notifications:General"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.projectUpdates,
            "onUpdate:modelValue": [
              _cache[8] || (_cache[8] = $event => ((_ctx.model.projectUpdates) = $event)),
              $options.onProjectUpdatesNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.notificationPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.ProjectUpdatesFieldLabel,
            name: "model.projectUpdates",
            layout: "columns",
            class: "_mt-0",
            description: _ctx.Resources.SubscriptionManagement.ProjectUpdatesInputFieldDescription,
            "data-qa": "general-notifications:Updates"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}